export enum InvoiceApi {
  search = '/invoice/search'
}
